module.exports = __webpack_public_path__ + "media/images/digivent/404-de7b6563d680b71a06d14437ded1a156.jpg";